import { h } from 'preact';

import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import AppBar from '@mui/material/AppBar';

import styles from '../../components/global.css';
import LazyCruxUrlRecord from '../../components/cruxUrlRecord/lazyCruxUrlRecord.jsx';
import { Skeleton } from '@mui/material';
import { UrlTable } from './_common.jsx';
import LazyDateSelect from '../../components/dateSelect/lazyDateSelect.jsx';

function LazyProprtyCruxOrigin(_props) {
  return (
    <>
      <AppBar
        position="static"
        color="transparent"
        elevation={0}
        sx={{ mt: -4 }}
      >
        <Skeleton width={'100%'} height={48} />
      </AppBar>

      <Paper className={styles.originArea}>
        <Skeleton width={'100%'} height={72} />
      </Paper>

      <Paper className={`${styles.originArea}`}>
        <div className={styles.dateHolder}>
          <Typography variant="h6">Timeline</Typography>
          <Skeleton width={580} height={58} />
        </div>

        <Paper className={`${styles.reportArea}`}>
          <Typography variant="h6">UX Distribution</Typography>
          <Skeleton width={'100%'} height={478} />
        </Paper>

        <Paper className={`${styles.reportArea}`}>
          <Typography variant="h6">P75 Value</Typography>
          <Skeleton width={'100%'} height={478} />
        </Paper>
      </Paper>

      <Paper className={`${styles.originArea}`}>
        <div className={styles.urlListHeader}>
          <Typography variant="h5">Analyzed URLs</Typography>
          <div>
            <LazyDateSelect />
          </div>
        </div>

        <UrlTable>
          {Array(15)
            .fill(null)
            .map((_, index) => (
              <LazyCruxUrlRecord key={index} />
            ))}
        </UrlTable>
      </Paper>
    </>
  );
}

export default LazyProprtyCruxOrigin;
